import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import * as httpClient from "../../util/httpClient";
import NeedHelp from "./NeedHelp";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const PreferredCommunicationOption = (props: any) => {
    const dispatch = useDispatch();
    const [state, setState] = useState({ communicationOptopn: "EMAIL", isLoading: false });
    const preferredCommunicationMediaList = useSelector((state: ApplicationState) =>
        state.forgotPasswordState && state.forgotPasswordState.communicationMethodList ? state.forgotPasswordState.communicationMethodList : []
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        window.scrollTo(0, 0);
        if (preferredCommunicationMediaList && preferredCommunicationMediaList.length === 0) {
            props.history.push("/forgot-password");
        }
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setState({ ...state, isLoading: true });
        const requestBody = {
            methodType: state.communicationOptopn,
        };

        window.addToDataLayer({ event: "Submit Communication Media" });

        httpClient
            .sendRequest("POST", `web/forgot-password/generate-temporary-password`, requestBody)
            .then((data) => {
                setState({ ...state, isLoading: false });

                props.history.push("/validate-password");
            })
            .catch(function (error) {
                setState({ ...state, isLoading: false });
            });

        dispatch({ type: "SELECT_COMMUNICATION_METHOD", selectedMethod: state.communicationOptopn });
    };

    const handleChange = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const maskedField = (field: any) => {
        let index = field.length - 4;
        let maskedFields = field.slice(0, index);
        return field.replace(maskedFields, "******");
    };

    return (
        <React.Fragment>
            <main id="l-page-content" aria-labelledby="title-page">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                Reset Password
                            </h1>
                        </div>
                    </div>
                    <div className="row margin-vertical-xl" id="content">
                        <div className="col-xs">
                            <div className={state.isLoading ? "box box-has-shadow box-xs offset-padding loading" : "box box-has-shadow box-xs offset-padding"}>
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-icon" aria-hidden="true">
                                            <RenderIcons iconName="key" />
                                        </div>
                                        <div className="box-title-text">
                                            <h2 className="box-title">Forgot Your Password?</h2>
                                        </div>
                                    </div>
                                    <div className="box-description">
                                        <p>Select delivery method for your temporary verification code.</p>
                                    </div>
                                </div>
                                <div className="box-content">
                                    <form id="form-forgot-password" onSubmit={() => props.history.push("/forgot-password-confirm")}>
                                        <div className="row">
                                            {preferredCommunicationMediaList.length > 0 &&
                                                preferredCommunicationMediaList.map((item, index) => {
                                                    if (item.methodType === "EMAIL") {
                                                        return (
                                                            <div className="form-row no-margin" key={index}>
                                                                <div className="form-input">
                                                                    <label className="form-radio-label" >
                                                                        <input
                                                                            type="radio"
                                                                            value={item.methodType}
                                                                            onChange={(e: any) => handleChange(e)}
                                                                            id="edit-card-1-card-category-credit-card"
                                                                            name="communicationOptopn"
                                                                            checked={state.communicationOptopn === item.methodType}
                                                                        />
                                                                        <span className="form-radio-label-text">
                                                                            <span className="bold">{item.methodType + ": "}</span>
                                                                            {item.recepientAddress}
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div className="form-row no-margin" key={index}>
                                                                <div className="form-input">
                                                                    <label className="form-radio-label" >
                                                                        <input
                                                                            type="radio"
                                                                            value={item.methodType}
                                                                            onChange={(e: any) => handleChange(e)}
                                                                            id="edit-card-1-card-category-credit-card"
                                                                            name="communicationOptopn"
                                                                            checked={state.communicationOptopn === item.methodType}
                                                                        />
                                                                        <span className="form-radio-label-text">
                                                                            <span className="bold">
                                                                                {item.methodType === "SMS" ? "Text Message: " : "Voice Call: "}
                                                                            </span>{" "}
                                                                            {maskedField(item.recepientAddress)}
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                        </div>

                                        <div className="margin-bottom-s"></div>

                                        <div className="form-row">
                                            <button type="submit" onClick={handleSubmit} className="btn-default btn-primary">
                                                <span className="btn-text">Submit</span>
                                            </button>
                                        </div>

                                        <div className="form-row">
                                            <button
                                                type="button"
                                                className="btn-default btn-link btn-no-padding btn-no-border"
                                                onClick={() => {
                                                    window.addToDataLayer({ event: "Back to Login" });
                                                    props.history.push("/");
                                                }}
                                            >
                                                <span className="btn-text">Back to Login</span>
                                            </button>
                                        </div>

                                        {!isLife360PartnerId && (
                                            <>
                                                <div className="line-divider margin-vertical-l"></div>
                                                <NeedHelp />
                                            </>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </React.Fragment>
    );
};

export default PreferredCommunicationOption;
